'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
var polished = require('polished');
var constants_legacy_theme = require('../../constants/legacy/theme.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var Link = styled__default["default"].a.withConfig({
  displayName: "Link",
  componentId: "sc-1fx6kz8-0"
})(["text-decoration:none;color:", ";cursor:pointer;&:hover{color:", ";}"], constants_legacy_theme.COLORS.PRIMARY, polished.darken(0.1, constants_legacy_theme.COLORS.PRIMARY));

exports["default"] = Link;
